// @ts-nocheck
import LocalizationHelper from '../../helpers/TranslationHelper';
import LocalizationContext from '../../shared/contexts/LocalizationContext';
import { LocalizationEntity } from '../../shared/models/localization';
import { useContext } from 'react';

export const AccessDeniedBox: React.FC = () => {
  const localization = useContext<Array<LocalizationEntity>>(LocalizationContext);

  return (
    <div className="card p-3 shadow-sm my-3" style={{ maxWidth: '500px', margin: '0 auto' }}>
      <h5 className="text-center text-danger mb-3">
        {LocalizationHelper.getLocaleEntityValue(
          localization,
          'ZSite.Frontend.Kanban.AccessDeniedTitle',
          'Access Denied'
        )}
      </h5>
      <p className="text-center text-muted mb-4">
        {LocalizationHelper.getLocaleEntityValue(
          localization,
          'ZSite.Frontend.Kanban.AccessDeniedMessage',
          'You do not have permission to view this board. Please contact your manager.'
        )}
      </p>
    </div>
  );
};
